import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from '../shared/service/user-session.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OverviewComponent {

  constructor(private router: Router,
        private userSessionService: UserSessionService) {}

    goToCoverage() {
      this.navigateToEdit('/coverage', { editCoverage: true });
    }

    goToEmployee() {
      if (this.isDependentApplication()) {
        this.navigateToView('/employee-information', { viewEmployee: true });
        return;
      }
      this.navigateToEdit('/employee-information', { editEmployee: true });
    }

    goToApplicant() {
      this.navigateToEdit('/applicant-information', { editApplicant: true });
    }

    goToMedicalHistory() {
      this.navigateToEdit('/medical-history', { editMedicalHistory: true });
    }

    goToPhysician() {
      this.navigateToEdit('/physician-information', { editPhysician: true });
    }

    private navigateToEdit(path: string, state: Record<string, boolean>) {
      this.router.navigate([path], {
        queryParams: { mode: 'edit' },
        state
      });
    }

    private navigateToView(path: string, state: Record<string, boolean>) {
      this.router.navigate([path], {
        queryParams: { mode: 'view' },
        state
      });
    }

    private isDependentApplication(): boolean {
      const applicantType = this.userSessionService.data?.applicantType?.toLowerCase();
      return applicantType === 'spouse' || applicantType === 'child';
    }
}
